<template>
  <Vue3Snackbar bottom>
    <template #message-content="{ message }">
      <p class="global-snackbar-text" v-text="message.title"></p>
    </template>
    <template #message-action="{ message }">
      <button
        v-if="message.text"
        class="vue3-snackbar-action-button"
        v-text="message.text"
        @click="message.action && message.action()"
      ></button>
    </template>
  </Vue3Snackbar>
</template>

<script lang="ts" setup>
// vue3-snackbarの仕様を少し悪用し、本来はRendererを仕込むactionに実行したい関数を渡して、アクションボタンを押したらそれを実行する仕様に変更している。
import { Vue3Snackbar } from 'vue3-snackbar'
</script>
<style lang="scss">
@use '@/assets/styles/scss/vue' as *;

#vue3-snackbar--container {
  width: 100%;
  margin: 0;

  @include is-desktop {
    width: max-content;
    max-width: calc(90vw - 32px);
    margin: 16px 16px 0;
  }

  .vue3-snackbar-message {
    margin: 0;
    border-radius: 0;

    @include is-desktop {
      margin-bottom: 16px;
      border-radius: 4px;
    }
  }
}

.vue3-snackbar-action-button {
  min-width: 3.5rem;
  border: none;
  border-bottom: 2px solid rgba(21,209,151,0.6);
  padding: 0.25rem 0.5rem;
  color: $white;
  font-weight: 700;
  cursor: pointer;
}

.vue3-snackbar-message {
  &.custom {
    border-color: $jps-gray-500 !important;
    background-color: $jps-gray-900 !important;
    .vue3-snackbar-action-button {
      &:hover {
        background-color: #353535;
      }
    }
  }
  &.error {
    border-color: #ef454a !important;
    background-color: #ef454a !important;
    .vue3-snackbar-action-button {
      border-color: white;
      &:hover {
        background-color: #f37478;
      }
    }
  }
  &.warning {
    border-color: #d1c115 !important;
    background-color: #d1c115 !important;
    .vue3-snackbar-action-button {
      border-color: white;
      color: $jps-gray-700;
      &:hover {
        background-color: #a89a10;
      }
    }
  }
  &.success {
    border-color: #196ac9 !important;
    background-color: #196ac9 !important;
    .vue3-snackbar-action-button {
      border-color: white;
      &:hover {
        background-color: #14549f;
      }
    }
  }
  min-width: 16rem;
  border-width: 1px;
  border-style: solid;
  .vue3-snackbar-message-wrapper {
    width: 100%;
    padding: calc(0.25rem * 2);
  }
  .vue3-snackbar-message-content {
    display: flex;
    width: 100%;
    flex-grow: 1;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: calc(0.25rem * 6);
    padding: 0;
  }
  .vue3-snackbar-message-icon {
    display: none;
  }
  .vue3-snackbar-message-badge {
    display: none;
  }
  .vue3-snackbar-message-action {
    display: none;
    &:has(button){
      display: block;
      width: auto;
      padding-top: 0;
    }
  }

  .spacer {
    display: none;
  }
  .vue3-snackbar-message-close {
    display: none;
  }
}
</style>
